var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91663 4.50002H12.8333V5.66669H11.6666V13.25C11.6666 13.4047 11.6052 13.5531 11.4958 13.6625C11.3864 13.7719 11.238 13.8334 11.0833 13.8334H2.91663C2.76192 13.8334 2.61354 13.7719 2.50415 13.6625C2.39475 13.5531 2.33329 13.4047 2.33329 13.25V5.66669H1.16663V4.50002H4.08329V2.75002C4.08329 2.59531 4.14475 2.44694 4.25415 2.33754C4.36354 2.22815 4.51192 2.16669 4.66663 2.16669H9.33329C9.488 2.16669 9.63638 2.22815 9.74577 2.33754C9.85517 2.44694 9.91663 2.59531 9.91663 2.75002V4.50002ZM10.5 5.66669H3.49996V12.6667H10.5V5.66669ZM7.82479 9.16669L8.85613 10.198L8.03129 11.0229L6.99996 9.99152L5.96863 11.0229L5.14379 10.198L6.17513 9.16669L5.14379 8.13535L5.96863 7.31052L6.99996 8.34185L8.03129 7.31052L8.85613 8.13535L7.82479 9.16669ZM5.24996 3.33335V4.50002H8.74996V3.33335H5.24996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTrashIcon);
export default __webpack_public_path__ + "static/media/NewTrashIcon.d4dd7a37e15a3d4780c8d4828b21d212.svg";
export { ForwardRef as ReactComponent };